import { isDebug } from "@/constants";
import { Context } from "@/context";
import { useContext } from "react";
import { OffscreenCanvas } from "./components/OffscreenCanvas";
import { WorkerStats } from "./components/WorkerStats";
import { usePhysicsWorkerListeners } from "./hooks/usePhysicsWorkerListeners";
import { useRenderedWorkerListeners } from "./hooks/useRenderedWorkerListeners";

export const DiceCanvases = () => {
  const { physicsWorker, renderedWorker } = useContext(Context);

  usePhysicsWorkerListeners();
  useRenderedWorkerListeners();

  if (!(physicsWorker && renderedWorker)) return;

  return (
    <>
      <OffscreenCanvas
        worker={physicsWorker}
        frameloop="demand"
        shadows
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 99999999999,
          pointerEvents: "none",
        }}
      />
      <OffscreenCanvas
        worker={renderedWorker}
        frameloop="demand"
        shadows
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 9999999999,
          pointerEvents: "none",
        }}
      />
      {isDebug && <WorkerStats />}
    </>
  );
};
